export default __webpack_public_path__ + "static/media/success.58c3a9f2.mp3";